import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class SignUpAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  createUser(params, router) {
    const url = "/api/signup/create";
    return this.CommonAPIService.postCall(url, params, router);
  }

  checkEmail(email, router) {
    const url = "/api/signup/checkEmail";
    return this.CommonAPIService.getCall(url, { email }, router);
  }

  login(params, router) {
    const url = "/api/signup/login";
    return this.CommonAPIService.postCall(url, params, router);
  }

  getUserFlightSchool(userId, router) {
    const url = `/api/signup/userFlightSchool/${userId}`;
    return this.CommonAPIService.getCall(url, {}, router);
  }

  saveUserFlightSchool(userId, params, router) {
    const url = `/api/signup/userFlightSchool/${userId}`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  getUserFinancing(userId, router) {
    const url = `/api/signup/userFinancing/${userId}`;
    return this.CommonAPIService.getCall(url, router);
  }

  saveUserFinancing(userId, params, router) {
    const url = `/api/signup/userFinancing/${userId}`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  getUserDocuments(userId, router) {
    const url = `/api/signup/userDocuments/${userId}`;
    return this.CommonAPIService.getCall(url, {}, router);
  }

  createOrUpdateUserDocuments(userId, params, router) {
    const url = `/api/signup/userDocuments/${userId}`;
    return this.CommonAPIService.newFileCall(url, params, router);
  }
}
export default SignUpAPIService;
